import React, { useState } from "react";
import crmImg from "../../common/images/p-3.png";
import webdevImg from "../../common/images/p-1.png";
import appdevImg from "../../common/images/p-4.png";
import automationImg from "../../common/images/p-5.png";
import uiuxImg from "../../common/images/p-2.png";

const HalfCircleDesign = ({ selected, setSelected }) => {
  const services = [
    {
      id: 5,
      img: automationImg,
      title: "Custom Software Development",
      description:
        "Delivering bespoke software solutions built for efficiency and growth.",
      mark: "customSoftwareDevelopment",
      position: "left-[0px] bottom-[0px]",

      link: "/custom-software-development",
    },
    {
      id: 4,
      img: appdevImg,
      title: "Android Development",
      description:
        "Building seamless, user-friendly mobile apps that enhance digital experiences…",
      mark: "appdev",
      position: "left-[100px] bottom-[200px]",
      link: "/android-development",
    },
    {
      id: 1,
      img: crmImg,
      title: "CRM Development",
      description:
        "CRM development enhances performance and user experience with  quality checks and seamless integrations.",
      mark: "crm",
      position: "right-[0px] bottom-[200px]",
      link: "/crm-development",
    },
    {
      id: 2,
      img: uiuxImg,
      title: "UI/UX Design",
      description:
        "Creating intuitive and visually stunning designs that captivate users…",
      mark: "uiux",
      position: "left-[100%] bottom-[0px]",
      link: "/uiux-designer",
    },
    {
      id: 3,
      img: webdevImg,
      title: "Web Development",
      description:
        "Crafting high-performance, scalable websites tailored to your business needs…",
      mark: "webdev",
      position: "left-[50%] -top-[50px]",
      link: "/website-development",
    },
  ];

  const selectedService =
    services.find((item) => item.id === selected) || services[0];

  return (
    <>
      <div className="text-center md:block hidden max-w-2xl mx-auto px-4 mb-24">
        <h3 className="text-webYellow text-3xl font-medium">
          Our Work. Our Excellence.
        </h3>
        <h2 className="text-blue-900 text-3xl small:text-4xl font-medium leading-tight mt-2">
          Showcasing Innovation Impact
        </h2>
        <p className="text-gray-700 mt-4 text-base">
          Explore our portfolio of cutting-edge web, mobile, and custom software
          solutions. From UI/UX design to seamless functionality, our work
          speaks for itself.
        </p>
      </div>
      <div className="relative md:block hidden w-[600px] h-[330px] mx-auto">
        <div
          className="absolute left-1/2 top-0 -translate-x-1/2 size-full 
                      bg-transparent border-[2px] border-b-0 border-dashed border-yellow-500 
                      rounded-t-full"
        ></div>

        <div className="absolute bottom-[20px] left-[50%] -translate-x-1/2 w-[300px] text-center">
          <h2 className="text-xl font-semibold">{selectedService.title}</h2>
          <p>
            {selectedService.description}{" "}
            {selectedService.link ? (
              <a
                href={selectedService.link}
                className="text-webOranage hover:underline"
              >
                View More 
              </a>
            ) : (
              ""
            )}
          </p>
        </div>

        {services.map((item, index) => (
          <div
            key={index}
            onClick={() => setSelected(item.id)}
            className={`absolute ${
              item.position
            } -translate-x-1/2 flex items-center justify-center 
            p-4 rounded-full shadow-md cursor-pointer transition-all duration-300 size-[100px]
            ${
              selected === item.id
                ? "bg-secondary text-white scale-125"
                : "bg-blue-200 text-yellow-500"
            }`}
          >
            <img
              src={item.img}
              alt={item.title}
              className={`${item.id === 4 ? "w-[40px]" : "size-full"}`}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default HalfCircleDesign;
